function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 213",
  d: "M219.265 112.641l-18.54 1.247a93.133 93.133 0 00-86.717 86.716l-1.249 18.584a1.956 1.956 0 01-3.911 0l-1.253-18.579a93.132 93.132 0 00-86.718-86.721l-18.54-1.252a1.839 1.839 0 010-3.677l18.54-1.252a93.131 93.131 0 0086.718-86.716l1.253-18.54a1.956 1.956 0 113.911 0l1.249 18.54a93.133 93.133 0 0086.758 86.716l18.539 1.252a1.839 1.839 0 11-.039 3.677z",
  fill: "none",
  stroke: "#3c00dc"
});

function SvgShineOutlinedSmallinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221.624,
    height: 221.644,
    viewBox: "0 0 221.624 221.644"
  }, props), _ref);
}

export default SvgShineOutlinedSmallinline;